import { encrypt } from '@/shared/services/encrypt';
import { setUserToken } from '@/shared/services/user-hash';
import type { TModule, TUserInfo } from '@/shared/types/user.types';

import { ApiConnector } from './api.connector';

class UserApi extends ApiConnector {
  async login(data: { email: string; password: string }) {
    const encData = encrypt(
      JSON.stringify({
        login: data.email,
        password: data.password
      })
    );
    const response: { accessToken: string; refreshToken: string } =
      await this.call({
        path: 'auth/login',
        method: 'post',
        body: { data: encData }
      });
    setUserToken({
      accessToken: response.accessToken,
      refreshToken: response.refreshToken
    });
    return response;
  }

  getUserAccount(): Promise<TUserInfo> {
    return this.call({ path: 'users/userAccount', method: 'get' });
  }

  getUserMenu(): Promise<TModule[]> {
    return this.call({ path: 'users/modules' });
  }
}

export const userApi = new UserApi();
